import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-jason-blog/src/templates/page.js";
import { OptIn, OptInNotice } from '$components';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Are you feeling overwhelmed with all the projects on your plate? Barely sleeping to keep up the demands of work and home? Working `}<em parentName="p">{`way`}</em>{` more than the 40 hours you’re supposed to?`}</p>
    <p>{`It’s obvious that the way we work `}<em parentName="p">{`isn’t working`}</em>{`. But how can you fix it?`}</p>
    <p>{`Does it feel like your only choices are:`}</p>
    <ol>
      <li parentName="ol">{`Tough it out, keep hustling, and hope things change after this next deadline, or`}</li>
      <li parentName="ol">{`Quit to save your sanity (not to mention your social life) and lose everything you’ve worked so hard to build?`}</li>
    </ol>
    <h2>{`There’s a third choice: you can have a great career and a great life.`}</h2>
    <p><strong parentName="p">{`The best part? You don’t have to make huge, sweeping changes to take back control of your life.`}</strong></p>
    <p>{`In reality, there’s no secret strategy or insider tip that will fix your balance. Instead, there are some small, practical, daily practices that will make an enormous difference in your level of happiness.`}</p>
    <h3>{`Learn 3 blindingly obvious (and therefore painfully underappreciated) daily actions that will change your life — starting today.`}</h3>
    <p>{`This guide will show you three small, immediately-applicable actions you can take `}<em parentName="p">{`today`}</em>{` that will help you:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Get motivated.`}</strong>{` Stop feeling buried. Start feeling unstoppable.`}</li>
      <li parentName="ul"><strong parentName="li">{`Supercharge your productivity.`}</strong>{` Show up, kick ass, get out, and live your life.`}</li>
      <li parentName="ul"><strong parentName="li">{`Create more quality time.`}</strong>{` Spend more time with the people you love.`}</li>
    </ul>
    <p>{`These daily actions — if you choose to `}<em parentName="p">{`actually follow through with them`}</em>{` — will change your life.`}</p>
    <p>{`And the best part is, making `}<strong parentName="p">{`these changes will have `}<em parentName="strong">{`no negative impact`}</em>{` on your career.`}</strong>{` (And, in fact, you’ll probably see things `}<em parentName="p">{`improve`}</em>{` at work.)`}</p>
    <h3>{`Are you ready to get your life back without sacrificing your career?`}</h3>
    <p>{`Get the free PDF guide delivered instantly. Just click the button and it’s yours.`}</p>
    <OptIn button="Get It Now" group="WORKHAPPY" source="/work-happier/" mdxType="OptIn" />
    <OptInNotice mdxType="OptInNotice">
  Note: I will never share your email or spam you with nonsense.
  Because I’m not a dick.
    </OptInNotice>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      